import EventBus from '@/events/EventBus';
import Events from '@/events/Events';

export default function ($matomo) {
  EventBus.$on(Events.LoggedIn, (params) => {
    $matomo.trackEvent('Login', Events.LoggedIn, params.type, 10);
  });
}
